import styled from 'styled-components';
import TextInput from '../../atoms/TextInput';
import {SearchIcon,RemoveIcon} from '../../atoms/Icons';
import IconButton from '../../atoms/IconButton';
import {DividerColor,Grey300,SurfaceColor} from '../../Colors';

export default {
	Wrapper : styled.div`
        border : 1px solid ${DividerColor};
        padding : 5px;
        border-radius:3px;
        background-color : ${SurfaceColor};
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: 1fr auto;
        & > #button-wrapper{
            display : flex;
            align-items : center;
        }
    `,
	IconButton : styled(IconButton)`
        color : ${Grey300};
        margin-right : 1rem;
        cursor : pointer;
    `,
	TextInput : styled(TextInput).attrs({
		borderType : 'none'
	})`
        width : 100%;
    `,
	RemoveIcon,
	SearchIcon
};